<template>
  <div class="LKPublicationsCardRecommendationRpshV3IndexMedianas">
    <div class="LKPublicationsCardRecommendationRpshV3IndexMedianas__title">
      Расчет средних индексов по региону
    </div>

    <div class="LKPublicationsCardRecommendationRpshV3IndexMedianas__description">
      Скачайте образец CSV с логинами школ, заполните по образцу
      и загрузите файл обратно. Нажмите кнопку "Запустить обработку" и отслеживайте выполнение задачи в таблице ниже.
      Переключатель полный перерасчет
      удаляет все старые значения индексов. По-умолчанию к имеющимся индексам добавляются не обработанные ранее школы.
    </div>

    <div class="LKPublicationsCardRecommendationRpshV3IndexMedianas__controls">
      <v-btn
        color="primary"
        outlined
        small
        :loading="isTemplateDownloading"
        :disabled="isTemplateDownloading"
        class="LKPublicationsCardRecommendationRpshV3IndexMedianas__button"
        @click="onDownloadTemplate"
      >
        Скачать образец CSV
      </v-btn>

      <v-btn
        color="primary"
        outlined
        small
        :loading="isMedianasDownloading"
        :disabled="isMedianasDownloading"
        class="LKPublicationsCardRecommendationRpshV3IndexMedianas__button"
        @click="onDownloadMedianas"
      >
        Скачать текущие средние индексы
      </v-btn>
    </div>

    <div class="LKPublicationsCardRecommendationRpshV3IndexMedianas__controls">
      <BFileInput
        v-model="file"
        accept=".csv,text/csv"
        label="CSV файл с логинами..."
        small-chips
        show-size
        hide-details="auto"
        class="LKPublicationsCardRecommendationRpshV3IndexMedianas__file"
        @change="onFileChange"
      />
      <div class="LKPublicationsCardRecommendationRpshV3IndexMedianas__run">
        <v-checkbox
          v-model="forced"
          label="полный перерасчет"
          dense
          hide-details
          class="LKPublicationsCardRecommendationRpshV3IndexMedianas__checkbox"
        />

        <v-btn
          color="primary"
          outlined
          small
          :loading="isUploading"
          :disabled="!canUpload"
          class="LKPublicationsCardRecommendationRpshV3IndexMedianas__button"
          @click="onUpload"
        >
          Запустить обработку
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import BFileInput from '@/components/forms/BFileInput.vue'
import { LkRecomendationApi } from '@/api/resources'
import { downloadLinkByGet } from '@/helpers/downloadBlob'

export default {
  name: 'LKPublicationsCardRecommendationRpshV3IndexMedianas',
  components: {
    BFileInput,
  },
  props: {
    publicationId: {
      type: Number,
      required: true,
    },
    recommendationAlgorithm: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    file: null,
    forced: false,
    isTemplateDownloading: false,
    isMedianasDownloading: false,
    isUploading: false,
  }),
  computed: {
    canUpload() {
      return Boolean(this.file && !this.isUploading)
    },
  },
  methods: {
    onFileChange(file) {
      this.file = file
    },
    async onDownloadTemplate() {
      const api = new LkRecomendationApi()
      this.isTemplateDownloading = true

      try {
        await downloadLinkByGet(api.getRpshV3IndexMedianasSchoolLoginsTemplateUrl())
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isTemplateDownloading = false
      }
    },
    async onDownloadMedianas() {
      const api = new LkRecomendationApi()
      this.isMedianasDownloading = true

      try {
        await downloadLinkByGet(
          api.getRpshV3IndexMedianasUrl(this.recommendationAlgorithm),
        )
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isMedianasDownloading = false
      }
    },
    async onUpload() {
      const api = new LkRecomendationApi()
      this.isUploading = true

      try {
        const result = await api.uploadRpshV3IndexMedianas(
          this.publicationId,
          this.file,
          this.forced,
        )
        this.file = null
        this.$notice.info('Запущена обработка средних индексов')
        this.$emit('uploaded', result)
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isUploading = false
      }
    },
  },
}
</script>

<style lang="scss">
.LKPublicationsCardRecommendationRpshV3IndexMedianas {
  margin-bottom: 14px;
  padding: 12px;
  border: 1px solid rgba(0, 0, 0, 0.10);
  border-radius: 4px;

  &__title {
    margin-bottom: 4px;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.3;
  }

  &__description {
    max-width: 760px;
    margin-bottom: 12px;
    color: rgba(0, 0, 0, 0.62);
    font-size: 12px;
    line-height: 1.45;
  }

  &__controls {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 12px;
    align-items: flex-start;

    & + & {
      margin-top: 10px;
    }
  }

  &__file {
    flex: 1 1 320px;
    max-width: 420px;
  }

  &__run {
    display: flex;
    flex: 0 1 auto;
    gap: 12px;
    align-items: center;
    min-height: 40px;
  }

  &__checkbox {
    flex: 0 0 auto;
    margin-top: 0 !important;
    padding-top: 0 !important;
  }

  &__button {
    min-height: 40px;
    margin-top: 0 !important;
  }
}
</style>
